import { Directive } from '@angular/core';

@Directive({ selector: '[carvectorPopoverTrigger]' })
export class PopoverTriggerDirective {}
